export enum Theme {
    Standard = "Standard",
    Dark = "Dark"
}